import { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Navigate } from "@tanstack/react-router";

import { RootLayout } from "@/modules/shared/layouts/Root";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootLayout,
  notFoundComponent: () => {
    return <Navigate to="/not-found" replace={true} />;
  },
});
